import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import IPv4 from "@/services/Utilities/ipv4";
import { validateSync } from "class-validator";

export default class CreateVHostForm {
  public websiteId: number = 0;
  public service: number = 0;
  public originServerHostname: string = '';
  public serverIps: string[] = [];
  public xdnEnabled: boolean = false;

  public rules: { [name: string]: FormValidationFunction[] } = {
    websiteIdRules: [
      (v: number) => !!v || v <= 0 || 'Domain is required',
    ],
    serviceRules: [
      (v: string) => !v || 'Service field is required',
    ],
    originServerHostnameRules: [
      (v: string) => !!v || 'Server field is required',
    ],
    customServerIpsRules: [
      (v: string[]) => {
        const ipObj = new IPv4();
        for (const ip of v) {
          ipObj.ip = ip;

          const err = validateSync(ipObj);
          if (err.length > 0) {
            return `'${ip}' is not a valid IP address`;
          }
        }

        return true;
      },
    ],
  };
}
